@if (isCounter) {
  <div class="carousel-counter">{{ counter }}</div>
}

<div class="carousel-container" [class.carousel-moving]="isMoving">
  <div
    class="carousel-cells"
    #cells
    (transitionend)="handleTransitionendCellContainer($event)"
    >
    <ng-content></ng-content>

    @for (image of images; track image; let i = $index) {
      @if (i < cellLimit) {
        <div
          class="carousel-cell"
          [style.width]="getCellWidth() + 'px'"
          [style.border-radius]="borderRadius + 'px'"
          >
          <!-- Image -->
          @if (getImage(i) && getImage(i)['image']) {
            <img
              [src]="getImage(i)['image']['path']"
              [style.object-fit]="objectFit"
              draggable="false"
              />
          }
        </div>
      }
    }
  </div>

  @if (dots) {
    <div class="carousel-dots">
      @for (dot of dotsArr; track dot; let i = $index) {
        <div
          class="carousel-dot"
          [class.carousel-dot-active]="i === activeDotIndex"
        ></div>
      }
    </div>
  }
</div>

@if (isArrows) {
  <div
    class="carousel-arrows"
    [class.carousel-arrows-outside]="arrowsOutside"
    [class.carousel-dark-arrows]="arrowsTheme === 'dark'"
    >
    <div
      class="carousel-arrow carousel-arrow-prev"
      [class.carousel-arrow-disabled]="isPrevArrowDisabled()"
      (click)="prev()"
    ></div>
    <div
      class="carousel-arrow carousel-arrow-next"
      [class.carousel-arrow-disabled]="isNextArrowDisabled()"
      (click)="next()"
    ></div>
  </div>
}
